import {DestroyRef,Injectable,inject} from '@angular/core';
import {ActivatedRouteSnapshot,NavigationEnd,Router} from '@angular/router';
import {filter} from 'rxjs';
import {logEvent,setUserId} from 'firebase/analytics';
import {onAuthStateChanged} from 'firebase/auth';
import {FIREBASE_ANALYTICS,FIREBASE_AUTH} from './firebase.tokens';

@Injectable({providedIn:'root'})
export class FirebaseTrackingService{
	private readonly router=inject(Router);
	private readonly resolveAnalytics=inject(FIREBASE_ANALYTICS);
	private readonly auth=inject(FIREBASE_AUTH);
	private readonly destroyRef=inject(DestroyRef);
	private started=false;

	start():void{
		if(this.started) return;
		const analytics=this.resolveAnalytics();
		if(!analytics) return;
		this.started=true;

		logEvent(analytics,'screen_view',{
			firebase_screen:this.router.url,
			firebase_screen_class:this.screenClass()
		});

		const subscription=this.router.events.pipe(
			filter((event):event is NavigationEnd=>event instanceof NavigationEnd)
		).subscribe((event)=>{
			logEvent(analytics,'screen_view',{
				firebase_screen:event.urlAfterRedirects,
				firebase_screen_class:this.screenClass()
			});
		});
		this.destroyRef.onDestroy(()=>subscription.unsubscribe());

		const unsubscribe=onAuthStateChanged(this.auth,(user)=>{
			setUserId(analytics,user?.uid??null);
		});
		this.destroyRef.onDestroy(unsubscribe);
	}

	private screenClass():string{
		let route:ActivatedRouteSnapshot=this.router.routerState.snapshot.root;
		while(route.firstChild) route=route.firstChild;
		return route.component instanceof Function ? route.component.name : 'Unknown';
	}
}
